






























































import Vue from 'vue'
import Component from 'vue-class-component'
import User from '@/provider/user'
import CircularLoading from '@/components/Loading/CircularLoading.vue'

@Component({
  components: {
    CircularLoading
  }
})
export default class PSWorksheet extends Vue {
  loading: boolean = true
  userId: string = ''
  userProvider!: User
  worksheetData = [
  ];

  async beforeMount () {
    this.userId = this.$route.params.userId
    this.userProvider = new User(this.userId)
    this.userProvider.getWorksheet('PS').then((result) => {
      this.worksheetData = result
      this.loading = false
    })
  }

  get worksheetCount () {
    return this.loading ? '' : this.worksheetData.length
  }
}
